import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=6a1ec436&scoped=true"
import script from "./SideBarItem.vue?vue&type=script&lang=js"
export * from "./SideBarItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&lang=css"
import style1 from "./SideBarItem.vue?vue&type=style&index=1&id=6a1ec436&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ec436",
  null
  
)

export default component.exports